import { render, staticRenderFns } from "./NotificationInTeam.vue?vue&type=template&id=1e730855&scoped=true&"
import script from "./NotificationInTeam.vue?vue&type=script&lang=js&"
export * from "./NotificationInTeam.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInTeam.vue?vue&type=style&index=0&id=1e730855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e730855",
  null
  
)

export default component.exports